import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter({customer_id, agro_exporter_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_containers/agro_exporter/${customer_id}/${agro_exporter_id}`
    );
  },
  fetchContainers({customer_id, agro_exporter_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_containers/${customer_id}/${agro_exporter_id}`
    );
  },
};
